// English — the source dictionary. Every key here must also exist in sw.ts
// (enforced by the type). Placeholders use {name}.
export const en = {
  // Shell
  "app.name": "Smart Safiri",
  "app.console": "Operations Console",
  "shell.changePassword": "Change password",
  "shell.logout": "Log out",
  "shell.language": "Language",
  "shell.administrator": "Administrator",

  // Nav sections
  "nav.section.Operations": "Operations",
  "nav.section.Finance": "Finance",
  "nav.section.Support": "Support",
  "nav.section.System": "System",

  // Nav items
  "nav.dashboard": "Classic overview",
  "nav.drivers": "Drivers",
  "nav.referrals": "Referrals & agents",
  "nav.trips": "Trips",
  "nav.users": "Riders",
  "nav.ride-types": "Ride Types & Pricing",
  "nav.toll-locations": "Toll Locations",
  "nav.tags": "Tags",
  "nav.coupons": "Promo codes",
  "nav.transactions": "Transactions",
  "nav.settlements": "Manual Settlements",
  "nav.payouts": "Driver Cash-outs",
  "nav.payout-catalogue": "Payout Destinations",
  "nav.tax-receipts": "Tax Receipts",
  "nav.latra": "LATRA Monthly",
  "nav.reports": "Reports",
  "nav.sos": "SOS Alerts",
  "nav.queries": "Support Queries",
  "nav.lost-items": "Lost & Found",
  "nav.admins": "Admin Users",
  "nav.audit": "Audit Log",
  "nav.settings": "Settings",

  // Common
  "common.all": "All",
  "common.search": "Search",
  "common.refresh": "Refresh",
  "common.date": "Date",
  "common.status": "Status",
  "common.none": "—",
  "common.lastDays": "Last {n} days",

  // Audit log
  "audit.title": "Audit Log",
  "audit.subtitle": "Every change made in the console — who, what and when",
  "audit.tab.activity": "Activity",
  "audit.tab.access": "Access review",
  "audit.search": "Search path, admin or action",
  "audit.writesOnly": "Changes only",
  "audit.col.when": "When",
  "audit.col.admin": "Admin",
  "audit.col.action": "Action",
  "audit.col.result": "Result",
  "audit.empty": "No activity recorded yet",
  "audit.outcome.allowed": "Allowed",
  "audit.outcome.denied": "Blocked",
  "audit.outcome.would_deny": "Would be blocked",
  "audit.detail.title": "Audit entry",
  "audit.detail.request": "Request",
  "audit.detail.admin": "Admin",
  "audit.detail.payload": "Payload",
  "audit.detail.change": "Change",
  "audit.detail.permission": "Permission",
  "audit.detail.duration": "Duration",
  "audit.access.mode": "Server-side role checks",
  "audit.access.mode.off": "Off",
  "audit.access.mode.log": "Logging only",
  "audit.access.mode.enforce": "Enforced",
  "audit.access.mode.logHelp":
    "Requests a role shouldn't make are recorded below but still allowed. When this list stays empty through normal use, enforcement can be switched on.",
  "audit.access.mode.enforceHelp":
    "Requests outside a role's permissions are refused by the API.",
  "audit.access.clean": "No refused requests in this window.",
  "audit.access.refusals": "Refused requests",
  "audit.access.matrix": "Role permissions",
  "audit.access.count": "Count",
  "audit.access.lastSeen": "Last seen",
  "audit.access.role": "Role",

  // ---- Operations console ----
  "shell.skipToContent": "Skip to content",
  "shell.menu": "Main menu",
  "shell.account": "Account menu",
  "nav.section.Command": "Command",
  "nav.section.Insights": "Insights",
  "nav.section.Compliance": "Compliance",
  "nav.section.Configuration": "Configuration",
  "nav.home": "Home",
  "nav.live": "Live operations",
  "nav.inbox": "Action inbox",
  "nav.finance": "Finance overview",
  "nav.analytics": "Analytics",
  "nav.monthly": "Monthly summary",
  "common.close": "Close",
  "common.noData": "No data for this period",
  "common.updated": "Updated {time}",
  "common.vsPrevious": "vs previous period",
  "window.period": "Period",
  "window.range": "Dates",
  "window.groupBy": "Group by",
  "window.auto": "Auto",
  "window.day": "Day",
  "window.week": "Week",
  "window.month": "Month",
  "window.today": "Today",
  "window.7d": "Last 7 days",
  "window.30d": "Last 30 days",
  "window.90d": "Last 90 days",
  "window.thisMonth": "This month",
  "window.lastMonth": "Last month",
  "window.thisYear": "This year",
  "window.custom": "Custom dates",
  "search.placeholder": "Search modules, actions, trips, drivers…",
  "search.empty": "Nothing matches — try a trip number, phone or plate",
  "search.group.recent": "Recent",
  "search.group.actions": "Actions",
  "search.group.modules": "Go to",
  "search.group.trips": "Trips",
  "search.group.drivers": "Drivers",
  "search.group.riders": "Riders",
  "search.hint.navigate": "to move",
  "search.hint.open": "to open",
  "search.action.onboardDriver": "Onboard a new driver",
  "search.action.reviewDrivers": "Review drivers waiting for approval",
  "search.action.stuckTrips": "Show stuck trips",
  "search.action.demandMap": "Where are drivers needed? (demand map)",
  "search.action.reassign": "Cancel, reassign or complete a trip",
  "search.action.activeSos": "Open SOS alerts",
  "search.action.recordSettlement": "Record a cash settlement",
  "search.action.cashReconciliation": "Cash reconciliation — who owes commission",
  "search.action.createPromo": "Create a promo code",
  "search.action.driverLeaderboard": "Driver scorecards",
  "search.action.monthlySummary": "Monthly summary (print / PDF)",
  "search.action.addAdmin": "Add an admin user",
  "search.action.accessReview": "Role access review",
  "search.action.changePassword": "Change my password",
  "search.action.toggleTheme": "Toggle dark mode",
  "search.action.switchLanguage": "Switch language",
  "search.action.darkMode": "Switch to dark mode",
  "search.action.lightMode": "Switch to light mode",
  "search.action.useSwahili": "Badili lugha: Kiswahili",
  "search.action.useEnglish": "Switch language: English",
  "home.morning": "Good morning",
  "home.afternoon": "Good afternoon",
  "home.evening": "Good evening",
  "home.openLive": "Open live board",
  "home.find": "Find anything",
  "home.vsYesterday": "vs same time yesterday",
  "home.kpi.requests": "Ride requests today",
  "home.kpi.completed": "Completed",
  "home.kpi.fulfilment": "Fulfilment rate",
  "home.kpi.fulfilmentHint": "Completed ÷ requests that have finished (completed, cancelled or no driver found).",
  "home.kpi.timeToAccept": "Avg time to accept",
  "home.kpi.riderPayments": "Rider payments",
  "home.kpi.safiriEarned": "Smart Safiri earned",
  "home.needsAttention": "Needs attention",
  "home.rightNow": "On the road right now",
  "home.supplyLine": "{idle} idle · {busy} busy · {waiting} waiting",
  "home.last14": "Last 14 days",
  "inbox.title": "Action inbox",
  "inbox.subtitle": "Everything waiting on someone, most urgent first",
  "inbox.viewAll": "View all",
  "inbox.allClear": "All clear — nothing needs attention right now.",
  "inbox.section.sos": "Active SOS alerts",
  "inbox.section.stuckTrips": "Stuck trips",
  "inbox.section.driverApprovals": "Drivers waiting for approval",
  "inbox.section.docExpiry": "Documents expiring within 30 days",
  "inbox.section.lowRated": "Low-rated drivers (under 4.0)",
  "inbox.section.debt": "Drivers over their cash limit",
  "inbox.section.payouts": "Failed or stuck driver cash-outs",
  "inbox.section.compliance": "LATRA & tax receipt failures",
  "inbox.section.queries": "Open support queries (oldest first)",
  "inbox.section.lostItems": "Open lost & found cases",
  "inbox.section.partWalletUnconfirmed": "Part-wallet trips with unconfirmed cash",
  "live.title": "Live operations",
  "live.subtitle": "Every driver and live trip right now",
  "live.autoRefresh": "Auto-refresh",
  "live.sosBanner": "{n} active SOS alert(s)",
  "live.filter.all": "All live",
  "live.filter.searching": "Searching",
  "live.filter.toPickup": "To pickup",
  "live.filter.atPickup": "At pickup",
  "live.filter.onTrip": "On trip",
  "live.filter.atDestination": "At destination",
  "live.filter.stuck": "Stuck",
  "live.layer": "Map layer",
  "live.layer.vehicles": "Vehicles",
  "live.layer.demand": "Demand vs supply",
  "live.demandWindow": "Demand window",
  "live.window.30m": "Last 30 min",
  "live.window.1h": "Last hour",
  "live.window.3h": "Last 3 hours",
  "live.window.24h": "Last 24 hours",
  "live.window.7d": "Last 7 days",
  "live.rideType": "Ride type",
  "live.allRideTypes": "All ride types",
  "live.idle": "Idle",
  "live.assigned": "Assigned",
  "live.busy": "On trip",
  "live.stale": "No signal",
  "live.searching": "Searching",
  "live.stuck": "Stuck",
  "live.onTrip": "On the road",
  "live.idleDrivers": "Idle drivers",
  "live.noMapKey": "The map needs a Google Maps key (VITE_GOOGLE_MAPS_API_KEY). Everything else on this board works without it.",
  "live.mapError": "The map couldn't load. Check the Google Maps key.",
  "live.selected": "Selected",
  "live.openTrip": "Open trip",
  "live.tab.trips": "Trips",
  "live.tab.drivers": "Drivers",
  "live.tab.demand": "Hotspots",
  "live.noTrips": "No live trips match.",
  "live.noDriver": "No driver yet",
  "live.findDriver": "Find driver, plate or phone",
  "live.demandHelp": "Areas ranked by requests (and requests with no driver found) per idle driver. Send drivers to the top of this list.",
  "live.showDemand": "Show demand on the map",
  "live.showHeatmap": "Demand heatmap",
  "live.noDemand": "No requests in this window.",
  "live.cell.title": "This area",
  "live.cell.requests": "{n} requests",
  "live.cell.unserved": "{n} with no driver found",
  "live.cell.idle": "{n} idle drivers now",
  "live.cell.line": "{r} req · {u} unserved · {d} idle",
  "live.rider": "Rider",
  "live.driver": "Driver",
  "live.inStatus": "{m} in this status",
  "live.lockedForDebt": "locked for debt",
  "live.lastSeen": "Last seen {time}",
  "actions.callDriver": "Call driver",
  "actions.callRider": "Call rider",
  "actions.driver": "Driver",
  "actions.rider": "Rider",
  "actions.intervene": "Intervene",
  "actions.reassign": "Reassign driver",
  "actions.forceComplete": "Complete & settle",
  "actions.cancelTrip": "Cancel trip",
  "actions.fault": "Who is this on?",
  "actions.faultHelp": "Recorded on the trip and used in cancellation analytics.",
  "actions.fault.platform": "Nobody — operational reason (incident, duplicate, test)",
  "actions.fault.rider": "The rider",
  "actions.fault.driver": "The driver",
  "actions.newDriver": "New driver",
  "actions.autoDispatch": "Re-dispatch automatically to the nearest available drivers",
  "actions.noIdleDrivers": "No idle drivers of this ride type nearby — use automatic re-dispatch.",
  "actions.reason": "Reason",
  "actions.reasonHelp": "Saved in the audit log with your name.",
  "actions.back": "Back",
  "actions.confirm.cancel": "Cancel this trip",
  "actions.confirm.reassign": "Reassign",
  "actions.confirm.complete": "Complete & settle",
  "actions.explain.cancel": "Both rider and driver are notified and the driver is freed for new trips. Nobody is charged.",
  "actions.explain.reassign": "The current driver is taken off the trip and notified. Call them too — older app versions may not show the change straight away.",
  "actions.explain.complete": "Settles the trip exactly as the driver's “cash collected” (or the wallet charge) would: payment, commission, driver balance, LATRA and tax receipt all run normally. Only do this once you've confirmed the rider paid.",
  "actions.done.cancel": "Trip cancelled",
  "actions.done.complete": "Trip completed and settled",
  "actions.done.assigned": "New driver assigned",
  "actions.done.searching": "Searching for a new driver",
  "actions.closeUnpaid": "Close as unpaid",
  "actions.refundWallet": "Refund wallet part",
  "actions.confirm.closeUnpaid": "Close trip as unpaid",
  "actions.confirm.refundWallet": "Refund to rider's wallet",
  "actions.explain.closeUnpaid": "Use when the rider did not pay the cash, or the trip is being cancelled after arrival. The trip completes, the driver still receives their full earning, and Smart Safiri absorbs whatever the rider did not pay.",
  "actions.explain.refundWallet": "Returns the wallet part of this completed trip to the rider as a “Trip refund”. The driver's earning stands; Smart Safiri absorbs the refund.",
  "actions.partSplit": "Wallet {wallet} (already taken) · cash {cash}",
  "actions.keepWallet": "Keep the wallet part against the fare",
  "actions.keepWalletHelp": "Off (default): the wallet part goes back to the rider.",
  "actions.done.closeUnpaid": "Trip closed as unpaid",
  "actions.done.refundWallet": "Wallet part refunded to the rider",
  "fin.title": "Finance overview",
  "fin.subtitle": "What riders paid, what Smart Safiri kept, and who owes whom",
  "fin.comparedWith": "Compared with {from} – {to}",
  "fin.riderPaid": "Rider payments",
  "fin.riderPaidHint": "What riders paid for completed trips (after discounts, incl. tolls and gateway fees).",
  "fin.safiriEarned": "Smart Safiri earned",
  "fin.safiriEarnedHint": "Commission + booking fees − discounts − VAT on booking fees.",
  "fin.takeRate": "Take rate",
  "fin.takeRateHint": "Smart Safiri earned ÷ rider payments.",
  "fin.trips": "Trips",
  "fin.avgFare": "Average fare",
  "fin.discounts": "Discounts given",
  "fin.discountsHint": "Promo-code discounts funded by Smart Safiri.",
  "fin.tab.overview": "Overview",
  "fin.tab.breakdown": "By method & ride type",
  "fin.tab.cash": "Cash & balances",
  "fin.tab.cashback": "Cashback",
  "cb.view.report": "Paid",
  "cb.view.pairs": "Repeat pairs",
  "cb.view.settings": "Settings",
  "cb.netCost": "Cashback cost",
  "cb.netCostHint": "Cashback granted in the period, minus what reversals took back. Written-off amounts stay a cost.",
  "cb.toPassengers": "To passengers",
  "cb.toDrivers": "To drivers",
  "cb.toDriversHint": "{amount} of it paid down commission drivers owed.",
  "cb.shareOfEarnings": "Share of Smart Safiri earnings",
  "cb.shareOfEarningsHint": "Cashback cost as a share of what Smart Safiri earned on the same rides (commission + booking fee − discount).",
  "cb.shareShort": "Of earnings",
  "cb.rides": "Rides",
  "cb.writtenOff": "Written off",
  "cb.writtenOffHint": "Passenger cashback already spent when it was reversed. {n} rides reversed.",
  "cb.overTime": "Cashback over time",
  "cb.passenger": "Passenger",
  "cb.driver": "Driver",
  "cb.records": "Cashback by ride",
  "cb.all": "All",
  "cb.grantedBadge": "Granted",
  "cb.reversed": "Reversed",
  "cb.granted": "Granted",
  "cb.trip": "Passenger → driver",
  "cb.rideType": "Ride type",
  "cb.fareBase": "Fare",
  "cb.offsetShort": "{amount} paid commission",
  "cb.writtenOffShort": "{amount} written off",
  "cb.reverse": "Reverse",
  "cb.noRecords": "No cashback in this period",
  "cb.reverseTitle": "Reverse cashback",
  "cb.reverseBody": "This takes back {passenger} from the passenger and {driver} from the driver.",
  "cb.reverseRules": "If the passenger already spent it, only their remaining balance is taken and the rest is written off. The driver's wallet can go negative; over the debt limit they cannot take new trips.",
  "cb.reason": "Reason (kept on record)",
  "cb.cancel": "Cancel",
  "cb.reversedOk": "Cashback reversed",
  "cb.reversedWithWriteOff": "Cashback reversed. {amount} was already spent and is written off.",
  "cb.pairsTitle": "Repeat passenger–driver pairs",
  "cb.pairsHelp": "Pairs with many short completed rides together in this period. Review them manually; nothing is flagged automatically.",
  "cb.pairsNext": "To act on a fraudulent ride, open it and reverse its cashback.",
  "cb.minRides": "At least (rides)",
  "cb.maxKm": "Rides up to",
  "cb.distance": "Distance",
  "cb.cashbackPaid": "Cashback",
  "cb.grantedOn": "on {n} rides",
  "cb.period": "First / last ride",
  "cb.noPairs": "No pairs above the threshold",
  "cb.settings": "Cashback settings",
  "cb.lastChanged": "Last changed {at} by {by}",
  "cb.programOn": "Program is ON",
  "cb.programOff": "Program is OFF",
  "cb.switchHelp": "Only rides completed while it is on earn cashback. Switching it on never pays for earlier rides; switching it off keeps cashback already granted.",
  "cb.passengerRate": "Passenger rate",
  "cb.driverRate": "Driver rate",
  "cb.overrides": "Ride type overrides",
  "cb.overridesHelp": "Leave a rate empty to use the default. Changes apply to new rides only.",
  "cb.pickRideType": "Pick a ride type",
  "cb.useDefault": "Default",
  "cb.removeOverride": "Remove override",
  "cb.addOverride": "Add ride type override",
  "cb.changeNote": "Note for the change log",
  "cb.changeNotePlaceholder": "Why are you changing this?",
  "cb.save": "Save settings",
  "cb.settingsSaved": "Cashback settings saved",
  "cb.readOnly": "Only the CEO and Finance team (finance.manage) can change cashback settings.",
  "cb.history": "Change log",
  "cb.when": "When",
  "cb.by": "By",
  "cb.program": "Program",
  "cb.rates": "Passenger / driver",
  "cb.note": "Note",
  "cb.on": "On",
  "cb.off": "Off",
  "cb.noHistory": "Never changed: the program is off at the launch rates.",
  "fin.overTime": "Over time",
  "fin.whereMoneyWent": "Where the money went",
  "fin.amount": "Amount",
  "fin.toDriver": "Driver earnings",
  "fin.toGateway": "Payment gateway fees",
  "fin.toLatra": "LATRA levy (passed to LATRA)",
  "fin.latraLevyRow": "LATRA levy",
  "fin.baseFareRow": "Base fare",
  "fin.distanceRow": "Distance",
  "fin.timeRow": "Time",
  "fin.waitingTimeRow": "Waiting time",
  "fin.rounding": "Rounding",
  "fin.inclTolls": "incl. {v} tolls passed to drivers",
  "fin.fareRow": "Fare",
  "fin.roundingRow": "Rounding (to the nearest 500)",
  "fin.waitingFeeRow": "of which waiting time",
  "fin.cancellationFeeRow": "Earlier cancellation fee",
  "fin.toCancelledTrip": "Cancellation fee (settled on the cancelled trip)",
  "fin.tollsRow": "Tolls",
  "fin.gatewayFeeRow": "Payment gateway fee",
  "fin.bookingFeeRow": "Booking fee",
  "fin.discountRow": "Discount",
  "fin.commissionRow": "Commission",
  "fin.vatOnCommissionRow": "VAT on commission",
  "fin.vatOnBookingFeeRow": "VAT on booking fee",
  "fin.waterfallLabel": "Of {paid} riders paid, Smart Safiri kept {kept}.",
  "fin.byPaymentMethod": "By payment method",
  "fin.byRail": "Money by rail: wallet {wallet} · cash {cash} · online {online}. {n} trips paid part wallet, part cash count in both.",
  "fin.byRideType": "By ride type",
  "fin.receivables": "Drivers owe Smart Safiri",
  "fin.receivablesHint": "Commission drivers still owe, mostly from cash trips.",
  "fin.payables": "Smart Safiri owes drivers",
  "fin.payablesHint": "Driver wallet balances available to cash out.",
  "fin.payoutsInFlight": "Cash-outs in progress",
  "fin.riderWallets": "Rider wallet balances",
  "fin.riderWalletsHint": "Money riders have topped up but not yet spent.",
  "fin.driversCount": "{n} drivers",
  "fin.countItems": "{n} cash-outs",
  "fin.lockedDrivers": "{n} driver(s) are locked out of new trips until they settle their balance.",
  "fin.commissionStatus": "Commission collection",
  "fin.commissionStatusHelp": "Commission on trips completed in this period, and whether it has been collected.",
  "fin.status": "Status",
  "fin.paymentMethod": "Payment method",
  "fin.oldestUncollected": "Oldest uncollected commission",
  "fin.oldestUncollectedHelp": "Drivers who have owed longest. Red = older than 7 days.",
  "fin.since": "Owed since",
  "fin.nothingOwed": "Nothing outstanding.",
  "an.title": "Analytics",
  "an.subtitle": "Service quality, drivers and riders over time",
  "an.tab.operations": "Operations",
  "an.tab.drivers": "Drivers",
  "an.tab.riders": "Riders",
  "an.requests": "Requests",
  "an.unserved": "No driver found",
  "an.unservedHint": "Share of requests where no driver accepted — lost demand.",
  "an.cancelRate": "Cancellation rate",
  "an.cancelSplit": "{r} by riders · {d} by drivers",
  "an.pickupTime": "Avg time to pickup",
  "an.promisedEta": "Promised ETA {m}",
  "an.outcomesOverTime": "Request outcomes",
  "an.completed": "Completed",
  "an.cancelled": "Cancelled",
  "an.noDriver": "No driver found",
  "an.speedOverTime": "Speed of service",
  "an.toAccept": "To accept",
  "an.toArrive": "To pickup",
  "an.onTrip": "On trip",
  "an.whenDemand": "When riders want rides",
  "an.whenDemandHelp": "Requests by day and hour (East Africa Time). Red corners mark hours where riders went unserved — schedule drivers there.",
  "an.heatmapLabel": "Ride requests by day of week and hour",
  "an.heatCell": "{day} {hour}: {n} requests, {u} with no driver",
  "an.fewer": "Fewer",
  "an.more": "More",
  "an.hadUnserved": "Some requests unserved",
  "an.dow.1": "Mon",
  "an.dow.2": "Tue",
  "an.dow.3": "Wed",
  "an.dow.4": "Thu",
  "an.dow.5": "Fri",
  "an.dow.6": "Sat",
  "an.dow.7": "Sun",
  "an.topPickups": "Busiest pickup points",
  "an.place": "Place",
  "an.cancelReasons": "Why trips were cancelled",
  "an.cancelledBy": "By",
  "an.reason": "Reason",
  "an.count": "Count",
  "an.byRideType": "By ride type",
  "an.approvedDrivers": "Approved drivers",
  "an.activeDrivers": "Active drivers",
  "an.activeDriversHint": "Drivers who completed at least one trip in the period.",
  "an.onlineNow": "Online now",
  "an.tripsPerDriver": "Trips per active driver",
  "an.acceptance": "Acceptance rate",
  "an.utilisation": "Utilisation",
  "an.utilisationHint": "Approximate share of online time spent on a trip (from online/offline toggles).",
  "an.scorecards": "Driver scorecards",
  "an.sortBy": "Sort drivers by",
  "an.sort.earnings": "Highest earnings",
  "an.sort.completed": "Most trips",
  "an.sort.acceptance": "Lowest acceptance",
  "an.sort.cancellations": "Most cancellations",
  "an.sort.rating": "Lowest rating",
  "an.offers": "Offers",
  "an.driverCancels": "Cancelled",
  "an.rating": "Rating",
  "an.earnings": "Earnings",
  "an.owes": "Owes Smart Safiri",
  "an.showingTop": "Showing the top {n} of {total} drivers — export for the full list.",
  "an.totalRiders": "Registered riders",
  "an.everRode": "{n} have ever taken a trip",
  "an.activeRiders": "Active riders",
  "an.activeRidersHint": "Riders with at least one completed trip in the period.",
  "an.repeatRate": "Repeat riders",
  "an.repeatRateHint": "Active riders who took 2+ trips in the period.",
  "an.tripsPerRider": "Trips per rider",
  "an.spendPerRider": "Spend per rider",
  "an.newRiders": "First-time riders",
  "an.newRidersHint": "Riders whose first-ever completed trip was in this period.",
  "an.growth": "Sign-ups vs first rides",
  "an.signups": "Sign-ups",
  "an.firstRides": "First rides",
  "an.cohorts": "Rider retention by first month",
  "an.cohortsHelp": "Of riders whose first trip was in a month (M0), the share who rode again 1, 2, 3… months later.",
  "an.cohort": "First month",
  "an.riders": "Riders",
  "monthly.title": "Monthly summary — {month}",
  "monthly.subtitle": "Generated {generated} · compared with the previous month",
  "monthly.month": "Month",
  "monthly.print": "Print / save as PDF",
  "monthly.headlines": "Headlines",
  "monthly.vsLastMonth": "vs last month",
  "monthly.h.trips": "{n} trips completed{c}.",
  "monthly.h.money": "Riders paid {paid}; Smart Safiri kept {kept}{c}, a {rate} take rate.",
  "monthly.h.fulfilment": "{rate} of finished requests were served; {unserved} requests found no driver.",
  "monthly.h.pickup": "Drivers took {m} on average to reach the rider.",
  "monthly.h.receivables": "Drivers currently owe Smart Safiri {v} ({n} drivers).",
  "monthly.topDrivers": "Top drivers by earnings",
  "monthly.unservedN": "{n} unserved",
  "fin.short.paid": "Rider paid",
  "fin.short.driver": "Driver",
  "fin.short.vatCommission": "VAT (driver)",
  "fin.short.vatBooking": "VAT (booking)",
  "fin.short.cancellationFee": "Cancel fee",
  "fin.short.gateway": "Gateway",
  "fin.short.latra": "LATRA",
  "fin.short.rounding": "Rounding",
  "fin.short.safiri": "Smart Safiri",
} as const;

export type TranslationKey = keyof typeof en;
